import { Route } from "react-router-dom";

import { VIEW_PERFORMANCE_GUARANTEE } from "src/constants";
import { PERFORMANCE_GUARANTEES_ROUTES } from "src/pages/performanceGuarantees/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { PerformanceGuarantees } from "./PerformanceGuarantees.page";
import { SinglePerformanceGuarantees } from "./SinglePerformanceGuarantees.page";

/** Route tree for the performance guarantee module, mounted under `/performance-guarantee`. */
export const performanceGuaranteesRoutes = (
  <>
    <Route
      path={PERFORMANCE_GUARANTEES_ROUTES.root}
      element={<ProtectedRoute permissions={VIEW_PERFORMANCE_GUARANTEE} component={PerformanceGuarantees} />}
    />
    <Route
      path={PERFORMANCE_GUARANTEES_ROUTES.details}
      element={<ProtectedRoute permissions={VIEW_PERFORMANCE_GUARANTEE} component={SinglePerformanceGuarantees} />}
    />
  </>
);
